import { useNavigate } from "react-router-dom"
import useLocalStorageState from "use-local-storage-state"

export const useGetEssentials = () => {
    // Session storage and authentication setup
    const [customer, setCustomer] = useLocalStorageState("customer")
    const navigate = useNavigate()
    const customerId = customer?.customer_details?.customer_id;
    const loginUserId = customer?.customer_details?.id;
    const userType = customer?.customer_details?.user_type;
    const token = customer?.token?.authorization;
    const rf = customer?.token?.authentication;

    // API headers configuration
    const headers = {
        Authentication: rf,
        Authorization: token,
    }

    const extras = {
        customer,
        setCustomer,
        rf,
        navigate,
    }

    return { customer, setCustomer, headers, extras, navigate, customerId, loginUserId, userType }
}